<template>
  <va-modal
    :value="isOpen"
    id="a4aSubtestDetailsModal"
    ref="a4aSubtestDetailsModal"
    :showOkay="false"
    @cancel="onClose"
    :fixed-layout="true"
    :size="'large'"
    :hideDefaultActions="true">
    <div slot="header" class="modal-title d-flex justify-content-between mb-0">
      <span>{{ $t('audiology_4_all.titles.testDetails') + " - " }} <span class="subtestTitle">{{ $t(`audiology_4_all.titles.tests.${subtest.subtest.slug}`)}} </span></span>
    </div>

    <div class="row col-12 mb-3" v-for="answer in subtest.answersGiven">
      <label class="is-bold ">{{ answer.question.text }}&ensp; </label>
      <!--<p>{{`${answer.answerText} (Max: ${answer.question.maxValueLabel})`}} </p>-->
      <p>{{ answer.answerText }} </p>
    </div>
  </va-modal>
</template>

<script>
export default {
  props: {
    subtest: {
      type: Object,
      required: true,
      default: null
    }
  },
  data: function () {
    return {
      isOpen: false
    }
  },
  mounted: function () {
    this.isOpen = true
  },
  methods: {
    onClose: function () {
      this.$emit('closeModal')
    }
  }
}
</script>

<style lang="scss">
label {
  color: $vue-green;
  font-size: 15px;

}
.subtestTitle {
  color: $vue-green;
}
</style>
